import { INSIGHTS } from "constants/action-types";

export const fetchProductSizeInsights = (productIds: string | string[] | undefined) => {
    if (!productIds) {
        return {
            type: INSIGHTS.FETCH_PRODUCT_SIZE_INSIGHTS.ERROR,
        };
    }

    return {
        type: INSIGHTS.FETCH_PRODUCT_SIZE_INSIGHTS.START,
        payload: {
            productIds,
        },
    };
};
